<template>
  <div name="demo-table-approve-all">
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :indexDisp="true"
                :approveDisp="true"
                :approveBtnDisp="true"
                :approveEvent="approveEvent"
                :detailEvent="detailEvent"
                :nowLang="nowLang" />
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.approveLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'approve', flgRowCondition)
let mockData = mock.dataApprove(flgRowCondition)

export default {
  name: 'demo-table-approve-all',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData
    }
  },
  methods: {
    detailEvent (dataRow) {
      console.log('Detail Event')
    },
    approveEvent (dataRow) {
      console.log('Approve Event')
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableApproveAll.vue?142dc5ec